
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';
import ListProducts from './ListProducts';
import BottleScreen from './bottle';
import ClassicCocktailsScreen from './classicCocktails';
import BeersScreen from './beers';
import Alcoholic from './alcoholic';

function Index({setShowHappy}) { 

     const {change, getInitData} = useRefresh();

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [signature, setsignature] = useState(false);
    const [frozen, setfrozen] = useState(false);
    const [classic, setclassic] = useState(false);
    const [bottle, setbottle] = useState(false);
    const [beers, setbeers] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [menusData, setMenusData] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
        const [showBottle, setShowBottle] = useState(false);
        const [showClassicCocktails, setShowClassicCocktails] = useState(false);
        const [showBeers, setShowBeers] = useState(false);
    
     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
            setMenusData(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 781) {
                setsignature(item);
            }
            if (item.id === 783) {
                setfrozen(item);
            }
            
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={setshowCategories} showCocktails={setShowCocktails} showEvents={setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                
                 <div style={{
                    background: '#4c473c',
                    width: '93%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '8px 10px',
                    gap: 15,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 12
                }}>
                    {menusData.map((item, key) => {
                            if (![767, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: '#d2c4a3',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '10px 25px',
                                    borderRadius: 10,
                                    minWidth: 'fit-content'
                            }}
                                    onClick={() => { 
                                    setShowListProduct(true)
                                    setdishs(item)
                                    
                                }}
                                >
                                <p className='shor-text' style={{color: 'black',  fontFamily: 'serif', fontSize: 16, margin: 0, textTransform: 'uppercase', fontWeight: '500'}}>{item.name}</p>

                            </div>
                            }
                            
                        })}
                </div>

                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{width: '100%', marginBottom: 2, position: 'relative'}}>
                        <div
                        onClick={() => {
                            setShowListProduct(true)
                            setdishs(frozen)
                        }}
                        >
                            <img
                            src={require('./assets/COLD-BEVERAGES.png')}
                            onContextMenu={(e) => e.preventDefault()}
                                style={{
                                marginTop: 100,
                                width: '100%',
                                height: 248,
                                marginBottom: 10,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>

                        <div
                        onClick={() => {
                            setShowListProduct(true)
                            setdishs(signature)
                        }}
                        >
                            <img
                            src={require('./assets/hot-drinks.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: '100%',
                                height: 248,
                                marginBottom: 10,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                        </div>

                       



                       
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showBottle && <BottleScreen setShowHappy={setShowBottle} />}
                {showClassicCocktails && <ClassicCocktailsScreen setShowHappy={setShowClassicCocktails} />}
                {showBeers && <BeersScreen setShowHappy={setShowBeers} />}
                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;